import React from 'react';

require('style/Slider');

export default class Slider extends React.Component {

  componentWillMount() {
    this.setState({
      value: parseFloat(this.props.defaultValue)
    });
  }

  componentWillReceiveProps(props) {
    if (this.hasFocus) return;
    this.setState({
      value: parseFloat(props.defaultValue)
    });
  }

  onFocus() {
    this.hasFocus = true;
  }

  onBlur() {
    this.hasFocus = false;
  }

  onChange(evt) {
    this.setState({value: evt.target.value})
    const value = parseFloat(evt.target.value);
    if (!isNaN(value) && this.props.onChange) {
      this.props.onChange(this.props.postfix ? value + this.props.postfix : value);
    }
  }

  render() {
    let inputProps = {
      min: this.props.min,
      max: this.props.max,
      step: this.props.step
    }
    return (
      <div className="Slider">
        <input
          type="range"
          {...inputProps}
          value={this.state.value}
          onChange={this.onChange.bind(this)}
        />
        <input
          type="number"
          {...inputProps}
          value={this.state.value}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onChange={this.onChange.bind(this)}
        />
        <span className="value">
          {this.props.postfix}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Slider.js